import { useTheme } from '@emotion/react';
import { Button, Typography, useMediaQuery, CircularProgress } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const Btn = ({
    type,
    bg,
    startIcon,
    disabled,
    endIcon,
    width = '500px',
    color,
    widthMob = '300px',
    br,
    onClick,
    sx,
    isLoad = true,
    path,
    children
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate()
    return (
        <Button
            onClick={onClick ? onClick : () => navigate(path)}
            variant="contained"
            // color={bg ? bg : '#00B8D7'}
            startIcon={disabled ? undefined : startIcon}
            endIcon={disabled ? undefined : endIcon}
            disabled={disabled}
            type={type}
            sx={{
                backgroundColor: bg ? bg : '#00B8D7',
                padding: { md: '10px 50px', xs: 2 },
                fontWeight: 'bold',
                fontSize: '16px',
                borderRadius: '35px',
                color: color ? color : theme.palette.secondary.text,
                width: { md: width, xs: widthMob },
                mx: 'auto',
                border: br && `1px solid ${color ? color : theme.palette.primary.main}`,
                height: '45px',
                '.MuiButton-endIcon': { mr: 1 },
                ...sx
            }}>
            {disabled && isLoad ? (
                <CircularProgress
                    size={isMobile ? 20 : 24}
                    sx={{ color: color || theme.palette.secondary.text, mx: 'auto' }}
                />
            ) : (
                <Typography component="span" variant={isMobile ? 'body1' : 'h6'} sx={{ fontFamily: 'URW DIN Arabic', fontSize: 17, fontWeight: 'medium' }}>
                    {children}
                </Typography>
            )}
        </Button>
    );
};

export default Btn;